var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/16px/ic chevron-main-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.4629 11.0137L11.2321 7.20597C11.3351 7.06466 11.3872 6.90093 11.3872 6.73678C11.3872 6.5997 11.3512 6.46263 11.2778 6.33739C11.1172 6.06239 10.8047 5.89062 10.4641 5.89062L4.92567 5.89062C4.58505 5.89062 4.27259 6.06239 4.11198 6.33739C4.03859 6.46262 4.00259 6.5997 4.00259 6.73678C4.00259 6.90093 4.05475 7.06466 4.15767 7.20639L6.9269 11.0141C7.09813 11.2493 7.38613 11.3906 7.6949 11.3906C8.00367 11.3906 8.29167 11.2493 8.4629 11.0137Z",
    fill: "#A7A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDark);
export default __webpack_public_path__ + "static/media/chevron-dark.5dbd87931d5780163b65531a401101cd.svg";
export { ForwardRef as ReactComponent };